import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { debounce } from 'lodash';
import Combobox from '@bubble-contrib/molecule-combobox';
import { withTooltip } from 'moet-core';

let onSearchDebounced;

const AutoSuggest = ({
  allowCustomValue = true,
  onChange = () => {},
  onSearch,
  onSelect = () => {},
  options = [],
  searchDebounce = 500,
  value: propsValue,
  ...otherProps
}) => {
  const selectedOption = options.find(o => o.value === propsValue);
  const customValue =
    propsValue && allowCustomValue ? { value: propsValue, label: propsValue } : undefined;

  const [value, setValue] = useState(selectedOption || customValue);

  useEffect(() => {
    onSearchDebounced =
      onSearch && typeof onSearch === 'function' ? debounce(onSearch, searchDebounce) : undefined;
  }, []);

  const onChangeHandler = ({ item, customValue }) => {
    setValue(item);
    onChange(item.value);
    if (!customValue) {
      onSelect(item.value);
    }
  };

  const onSearchHandler = val => {
    if (onSearchDebounced) {
      onChange(val);
      onSearchDebounced(val);
    }
  };

  return (
    <Combobox
      onChange={onChangeHandler}
      onSearch={onSearchHandler}
      value={value}
      options={options}
      allowCustomValue={allowCustomValue}
      {...otherProps}
    />
  );
};

AutoSuggest.propTypes = {
  allowCustomValue: PropTypes.bool,
  options: PropTypes.array,
  searchDebounce: PropTypes.number,
  value: PropTypes.string,
  onChange: PropTypes.func,
  onSearch: PropTypes.func,
  onSelect: PropTypes.func,
};

export default withTooltip(AutoSuggest);
